import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Pagination from 'react-js-pagination'

const TablePagination = ({ pagination, onChangePage, onChangePerPage }) => {
	return (
		<div className="TablePagination">
			<div>
				<Pagination
          activePage={pagination.page}
          itemsCountPerPage={pagination.limit}
          totalItemsCount={pagination.totalDocs}
          pageRangeDisplayed={10}
          onChange={onChangePage}
        />
        total results: {pagination.totalDocs}<br />
        total pages: {pagination.totalPages}
      </div>

      {
      	onChangePerPage
      	&& (
		      <div>
		    		results per page:&nbsp;
						<select onChange={(e) => onChangePerPage(e.target.value)} value={pagination.limit}>
							<option value="5">5</option>
							<option value="10">10</option>
							<option value="25">25</option>
							<option value="50">50</option>
							<option value="100">100</option>
						</select>
					</div>
      	)
      }

		</div>
	)

}

TablePagination.propTypes = {
	onChangePage: PropTypes.func.isRequired,
	onChangePerPage: PropTypes.func,
	pagination: PropTypes.shape({
		page: PropTypes.number.isRequired,
		limit: PropTypes.number.isRequired,
		totalDocs: PropTypes.number.isRequired,
		totalPages: PropTypes.number.isRequired,
	})
}

export default TablePagination;


// WEBPACK FOOTER //
// ./src/components/DataTable/components/TablePagination.jsx